import React from 'react'
import rowRight from '../images/btn-right.png'
interface Props {
    onClickFunction: () => void;
}
const ArrowRightButton: React.FC<Props> = ({ onClickFunction }) => {
    return (
        <div style={{
            position: 'absolute',
            top: '50%',
            right: '5.6vw',
            transform: 'translateY(-50%)',
            backgroundColor: 'transparent'
        }}>
            <button onClick={onClickFunction} style={{
                border: 'transparent',
                backgroundColor: "transparent",
                cursor: 'pointer',
                outline: 'none'
            }}>
                <img src={rowRight} alt="rowRight" style={{
                    height: 'calc(3vw + 15px)',
                    transition: 'transform 0.3s ease', // Agrega transición para suavizar la transformación
                }} />
            </button>

        </div>
    )
}

export default ArrowRightButton
